// extracted by mini-css-extract-plugin
export default {"root":"BrandIconCard_root__agYL3"};